import { DateRange } from "./DateRange";
import { LogLevel } from "./LogLevel";

export class LogEntryQuery {
    instance?: string;
    contextId?: string;
    category?: string;
    levels?: LogLevel[];
    dateRange?: DateRange;
    lastdate?: Date;
    lastId?: string;
}